import React, { useState } from 'react';
import interviewService from '../services/interviewService';

const CancelInterviewModal = ({ interview, onClose, onSuccess }) => {
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (reason.trim().length < 10) {
      setError('Cancellation reason must be at least 10 characters');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await interviewService.cancelInterview(interview._id, reason);

      if (response.success) {
        onSuccess();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to cancel interview');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] p-5" onClick={onClose}>
      <div className="bg-white rounded-lg shadow-[0_4px_20px_rgba(0,0,0,0.3)] max-w-[600px] w-full max-h-[90vh] overflow-y-auto md:max-w-full md:m-0" onClick={(e) => e.stopPropagation()}>
        <div className="flex justify-between items-center px-6 py-5 border-b border-[#e9ecef]">
          <h2 className="m-0 text-[#2c3e50] text-2xl">Cancel Interview</h2>
          <button className="bg-transparent border-none text-[2rem] text-[#6c757d] cursor-pointer p-0 w-8 h-8 flex items-center justify-center rounded transition-all duration-200 hover:bg-[#f8f9fa] hover:text-[#2c3e50]" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          {error && <div className="bg-[#f8d7da] text-[#721c24] px-4 py-3 rounded-md mb-5 border border-[#f5c6cb] text-[0.95rem]">{error}</div>}

          <div className="mb-5">
            <label htmlFor="reason" className="block mb-2 font-medium text-[#495057] text-[0.95rem]">Cancellation Reason *</label>
            <textarea
              id="reason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Please provide a reason for cancellation (minimum 10 characters)..."
              rows={4}
              minLength={10}
              maxLength={500}
              disabled={loading}
              required
              className="w-full px-3 py-2.5 border border-[#ced4da] rounded-md text-base transition-[border-color] duration-200 resize-y font-[inherit] focus:outline-none focus:border-[#007bff] focus:shadow-[0_0_0_3px_rgba(0,123,255,0.1)] disabled:bg-[#e9ecef] disabled:cursor-not-allowed"
            />
            <small className="block mt-1 text-[#6c757d] text-[0.85rem]">{reason.length}/500 characters (minimum 10)</small>
          </div>

          <div className="flex justify-end gap-3 mt-6 pt-5 border-t border-[#e9ecef] md:flex-col-reverse md:[&>button]:w-full">
            <button type="button" className="px-5 py-2.5 border-none rounded-md text-base font-medium cursor-pointer transition-all duration-200 bg-[#6c757d] text-white hover:bg-[#5a6268] disabled:opacity-60 disabled:cursor-not-allowed" onClick={onClose} disabled={loading}>
              Keep Interview
            </button>
            <button type="submit" className="px-5 py-2.5 border-none rounded-md text-base font-medium cursor-pointer transition-all duration-200 bg-[#dc3545] text-white hover:bg-[#c82333] disabled:opacity-60 disabled:cursor-not-allowed" disabled={loading || reason.length < 10}>
              {loading ? 'Cancelling...' : 'Cancel Interview'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CancelInterviewModal;
